import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, inject } from '@angular/core';
import { ApplicationRoute } from 'app/models/application-route';
import { LoginResponse, OidcSecurityService } from 'angular-auth-oidc-client';
import { LoadingIndicatorComponent } from '../loading-indicator/loading-indicator.component';
import { LoggerService } from 'app/services/logger.service';
import { AdminService } from 'app/services/admin.service';
import { AuthType } from 'app/models/auth-type';

@Component({
    selector: 'zf-login',
    template: '<div style="width:100%; height: calc(100vh - 102px);"></div><zf-loading-indicator></zf-loading-indicator>',
    imports: [LoadingIndicatorComponent]
})
export class AdminLoginComponent implements OnInit {
    private router = inject(Router);
    private route = inject(ActivatedRoute);
    private oidcSecurityService = inject(OidcSecurityService);
    private adminService = inject(AdminService);
    private logger: ReturnType<LoggerService['getScopedLogger']>;
    private loggerService = inject(LoggerService);

    constructor() {
        this.logger = this.loggerService.getScopedLogger('AdminLoginComponent');
    }

    public ngOnInit(): void {
        // check, and subscribe
        // to changes on the authentication state
        this.oidcSecurityService
            .checkAuth(null, AuthType.EMPLOYEE_FAC)
            .subscribe((loginRes: LoginResponse) => {

                this.logger.warn("Admin log in attempt");

                if (!loginRes.isAuthenticated) {

                    this.logger.error('Admin was not authenticated, redirecting...');
                    this.adminService.clearAuthenticated();
                    this.router.navigateByUrl(ApplicationRoute.SPLASH);
                    return;
                }
                const data = this.route.snapshot.queryParamMap.get('state');

                this.logger.debug("state: ", data);

                this.logger.warn("Admin user successfully authenticated");
                this.adminService.setAuthenticated();
                this.router.navigateByUrl("admin/deployments");
            });
    }
}
